module.exports = __webpack_public_path__ + "assets/media/level-04.6029872a.png";